import React, {FC, forwardRef} from 'react';
import {addDays, subDays} from 'date-fns';
import format from 'date-fns/format';
import ReactDatePicker from 'react-datepicker';
import {MdArrowLeft, MdArrowRight} from 'react-icons/md';
import {HStack, IconButton, Input, InputGroup, InputRightElement} from 'components/ui/chakra';
import {CalendarIcon} from 'components/ui/icons';
import 'react-datepicker/dist/react-datepicker.css';
import '../theme/date-picker.css';

interface DatePickerProps {
	value: Date;
	onChange: (date: Date) => void;
	size?: 'sm' | 'md' | 'lg';
	width?: string | number;
}

type DateInputProps = {
	onClick?: React.MouseEventHandler<HTMLDivElement>;
	value?: string;
};

const DatePicker: FC<DatePickerProps> = ({value, onChange, size = 'md', width = '13.5rem'}) => {
	const handlePrevious = () => {
		onChange(subDays(value, 1));
	};

	const handleNext = () => {
		onChange(addDays(value, 1));
	};

	const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
		({value: inputValue, onClick}, ref) => (
			<HStack align='stretch' spacing={1} w={width}>
				<IconButton
					aria-label='Previous date'
					icon={<MdArrowLeft />}
					onClick={(event) => {
						event.stopPropagation();
						handlePrevious();
					}}
					size={size}
					variant='ghost'
				/>
				<InputGroup flex={1} onClick={onClick}>
					<Input
						ref={ref}
						bgColor='white'
						cursor='pointer'
						readOnly
						size={size}
						value={inputValue}
					/>
					<InputRightElement pointerEvents='none'>
						<CalendarIcon color='gray.500' />
					</InputRightElement>
				</InputGroup>
				<IconButton
					aria-label='Next date'
					icon={<MdArrowRight />}
					onClick={(event) => {
						event.stopPropagation();
						handleNext();
					}}
					size={size}
					variant='ghost'
				/>
			</HStack>
		),
	);

	return (
		<div className='light-theme'>
			<ReactDatePicker
				customInput={<DateInput />}
				dateFormat='yyyy-MM-dd'
				popperClassName='provider-home-date-picker-popper'
				portalId='provider-home-date-picker-portal'
				onChange={(date) => {
					if (date) {
						onChange(date);
					}
				}}
				selected={value}
				showPopperArrow={false}
				value={format(value, 'yyyy-MM-dd')}
			/>
		</div>
	);
};

export default DatePicker;
